const signatureQaKey = 'Signatureqa';

/**
 * Safely get Signatureqa from localStorage
 */
export function getSignatureQa() {
    try {
        return localStorage.getItem(signatureQaKey);
    } catch {
        return null;
    }
}

/**
 * Merge new data into existing Signatureqa in localStorage
 * Prevents overwriting important fields unintentionally
 * Fallback: best effort write of incoming only
 */
export function mergeSignatureQa(incoming = {}) {
    try {
        const existingRaw = localStorage.getItem(signatureQaKey);
        const existing = existingRaw ? JSON.parse(existingRaw) : {};

        const merged = {
            ...existing,
            ...incoming,
        };

        localStorage.setItem(signatureQaKey, JSON.stringify(merged));
        return merged;
    } catch {
        try {
            localStorage.setItem(signatureQaKey, JSON.stringify(incoming));
        } catch { }
        return incoming;
    }
}

/**
 * Replace Signatureqa completely (use carefully)
 */
export function setSignatureQa(data = {}) {
    try {
        localStorage.setItem(signatureQaKey, JSON.stringify(data));
        return data;
    } catch {
        return null;
    }
}

/**
 * Remove Signatureqa from localStorage
 * Intentionally silent catch
 */
export function invalidateSignatureQa() {
    try {
        localStorage.removeItem(signatureQaKey);
    } catch {}
}
